<template>
  <div v-if="isEnabled">
    <!-- Elemento de audio persistente para WebRTC -->
    <audio ref="remoteAudio" id="remoteAudio" autoplay />

    <!-- Modal nativo -->
    <call-modal />
  </div>
</template>

<script>
import SipClient from 'dashboard/helper/SipClient';
import CallModal from 'dashboard/components/telephony/CallModal.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export default {
  name: 'TelephonyBridge',
  components: { CallModal },
  data() {
    return {
      isInitialized: false,
    };
  },
  computed: {
    isEnabled() {
      const nativeEnabled = !!window?.chatwootConfig?.telephonyNativeEnabled;
      const accountId = this.accountId;
      const isFeatureEnabled =
        this.$store?.getters?.['accounts/isFeatureEnabledonAccount'];
      const hasSipFeature =
        typeof isFeatureEnabled === 'function'
          ? !!isFeatureEnabled(accountId, FEATURE_FLAGS.CHANNEL_SIP)
          : false;
      const hasWhatsappCallingFeature =
        typeof isFeatureEnabled === 'function'
          ? !!isFeatureEnabled(accountId, FEATURE_FLAGS.WHATSAPP_CALLING)
          : false;

      return nativeEnabled && (hasSipFeature || hasWhatsappCallingFeature);
    },
    accountId() {
      return this.$store.getters.getCurrentAccountId;
    },
  },
  watch: {
    accountId() {
      this.tryInitialize();
    },
  },
  mounted() {
    window.addEventListener('chatwoot:telephony:dial', this.onDialEvent);
    this.tryInitialize();

    // cablear audio global al SipClient
    const sipClient = SipClient.getInstance();
    sipClient.setRemoteAudioElement(this.$refs.remoteAudio);
  },
  beforeDestroy() {
    window.removeEventListener('chatwoot:telephony:dial', this.onDialEvent);
  },
  methods: {
    onDialEvent(e) {
      const detail = e?.detail || {};
      const phoneNumber = detail.phoneNumber || '';
      if (!phoneNumber) return;
      this.$store.dispatch('telephony/PREPARE_DIAL', {
        phoneNumber,
        contactId: detail.contactId,
        conversationDisplayId: detail.conversationDisplayId,
      });
    },
    tryInitialize() {
      if (!this.isEnabled) return;
      if (!this.accountId) return;
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.$store.dispatch('telephony/CONNECT');
    },
  },
};
</script>

